import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconBox.tsx
const OutlinedFilledBox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06 5.5-15.18 15.69-27.9L189-836q12.75-16.03 30.61-23.02Q237.47-866 258-866h444q19.5 0 37.37 6.98Q757.24-852.03 770-836l74.81 95.04q9.19 12.72 15.19 27.9 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm431 87H307v344l173-87 174 87v-344Z" })
});
const OutlinedBox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-639v450h582v-450H654v344l-174-87-173 87v-344H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06 5.5-15.18 15.69-27.9L189-836q12.75-16.03 30.61-23.02Q237.47-866 258-866h444q19.5 0 37.37 6.98Q757.24-852.03 770-836l74.81 95.04q9.19 12.72 15.19 27.9 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm171 87v203l86-43 87 43v-203H394Zm-205 0h582-582Z" })
});
const RoundedFilledBox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-95q12.75-16.03 30.82-23.02Q237.88-866 258-866h444q19.09 0 37.16 6.98Q757.24-852.03 770-836l75 95q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm431 87H307v267q0 26 22 40.5t45 2.5l106-53 106 53q23 12 45.5-2.5T654-372v-267Z" })
});
const RoundedBox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-639v450h582v-450H654v267q0 26-22.5 40.5T586-329l-106-53-106 53q-23 12-45-2.5T307-372v-267H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06 5.5-15.18 15.69-27.9L189-836q12.75-16.03 30.61-23.02Q237.47-866 258-866h444q19.5 0 37.37 6.98Q757.24-852.03 770-836l74.81 95.04q9.19 12.72 15.19 27.9 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm171 87v203l86-43 87 43v-203H394Zm-205 0h582-582Z" })
});
const SharpFilledBox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-95v-620l118-151h534l119 151v620H95Zm128-631h513l-36-46H259l-36 46Zm84 431 173-87 174 87v-344H307v344Z" })
});
const SharpBox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-639v450h582v-450H654v344l-174-87-173 87v-344H189ZM95-95v-620l118-151h534l119 151v620H95Zm128-631h513l-36-46H259l-36 46Zm171 87v203l86-43 87 43v-203H394Zm-205 0h582-582Z" })
});
const componentMap = {
	outlined: OutlinedBox,
	"outlined-fill": OutlinedFilledBox,
	rounded: RoundedBox,
	"rounded-fill": RoundedFilledBox,
	sharp: SharpBox,
	"sharp-fill": SharpFilledBox
};
const IconBox = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconBox };